import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvService } from 'gematik-form-library';

export interface LicenseDto {
  licenseConfigId: number;
  nameDe: string;
  nameEn: string;
  descriptionDe: string;
  descriptionEn: string;
  activeLicenseGroupName: string;
  eligibilityGroupName: string;
  enterpriseAppName: string;
  eligible: boolean;
  activeLicense: boolean;
  maxLicenses: number;
  /** Name of the license pool, null if the license has no pool. */
  licensePool: string | null;
  activeLicenseCount: number;
  /** Consumption of the whole license pool; availableLicenses is computed from it. */
  poolActiveLicenseCount: number;
  availableLicenses: number;
  selfServiceThreshold: number;
  selfServiceUnlocked: boolean;
}

export interface LicenseErrorResponse {
  errorCode:
    | 'LICENSE_ELIGIBILITY_MISSING'
    | 'LICENSE_SELF_SERVICE_LOCKED'
    | 'LICENSE_ALREADY_ASSIGNED'
    | 'LICENSE_CAPACITY_EXCEEDED';
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  constructor(private http: HttpClient, private env: EnvService) {}

  getEligibleLicenses(): Observable<LicenseDto[]> {
    return this.http.get<LicenseDto[]>(this.env.backendUrl + '/uwl/licenses/eligible');
  }

  claimLicense(licenseId: number): Observable<any> {
    return this.http.post<any>(this.env.backendUrl + `/uwl/licenses/${licenseId}/claim`, null);
  }

  releaseLicense(licenseId: number): Observable<void> {
    return this.http.post<void>(this.env.backendUrl + `/uwl/licenses/${licenseId}/release`, null);
  }
}
